import TicketCreate from './create'
import Ticket from './ticket'
import TicketOverview from './overview'
module.exports = {
  TicketCreate,
  Ticket,
  TicketOverview
}



// WEBPACK FOOTER //
// ./src/projects/access-gui/views/ticket/index.js